<div fxLayout="row" fxFlex="grow"
     style="background-color: white; border-radius: 10px; padding:10px;">
    <div fxLayout="column" fxFlex>

        <div fxLayout="row" fxFlex>
            <ngx-skeleton-loader fxFlex="grow" count="1" animation="progress"
                                 [theme]="{ width: '100%', height: '24px' }"></ngx-skeleton-loader>
        </div>
        <div fxLayout="row" fxFlex>
            <ngx-skeleton-loader fxFlex="grow" count="1" animation="progress"
                                 [theme]="{ width: '100%', height: '24px' }"></ngx-skeleton-loader>
        </div>
        <div fxLayout="row" fxFlex>
            <ngx-skeleton-loader fxFlex="grow" count="1" animation="progress"
                                 [theme]="{ width: '100%', height: '24px' }"></ngx-skeleton-loader>
        </div>

    </div>

</div>
